const ArrowLeftIcon = () => (
    <svg height="20" viewBox="0 0 48 48" width="20" xmlns="http://www.w3.org/2000/svg">
        <path d="M30.83 32.67l-9.17-9.17 9.17-9.17-2.83-2.83-12 12 12 12z" fill="#6200ee" />
        <path d="M0-.5h48v48h-48z" fill="none" />
    </svg>
)

export default ArrowLeftIcon



// WEBPACK FOOTER //
// ./components/Icons/ArrowLeftIcon.js